export const FETCH_ACCESS = 'FETCH_ACCESS'
export const FETCH_ACCESS_SUCCESS = 'FETCH_ACCESS_SUCCESS'
export const FETCH_ACCESS_FAILED = 'FETCH_ACCESS_FAILED'
